module.exports = {
  QuickEntry: 'QuickEntry',
  LastRefreshTime: 'Last updated',
  SopBoard: 'SOPBoard',
  SeaExport: 'SeaExport',
  SeaImport: 'SeaImport',
  AirExport: 'AirExport',
  AirImport: 'AirImport',
  RailwayExport: 'RailwayExport',
  RailwayImport: 'RailwayImport',
  IntegratedJob: 'Integrated Job',
  BusinessVolumeGraph: 'BusinessVolumeGraph',
  PackUp: 'Shrink',
  Unfold: 'Unfold',
  SopReveal: 'SOPReveal',
  SopFilterConditions: 'SOPFilterConditions',
  SaveSucceed: 'Saved successfully',
  QuickEntryPopover: {
    FirstLine: '1、You can drag and drop any function from the menu bar to the shortcut entry',
    SecondLine: '2、When there are more than one line of shortcut entry display will automatically wrap the display.'
  },
  SopBoardPopover: {
    FirstLine: '1、The SOP panel counts only the businesses that you can view and shows only the nodes and states that you have checked.',
    SecondLine: '2、The node state of the business becomes "Done" and does not appear on the node.',
    ThirdLine: '3、Moving the cursor over the node will pop up the status you checked on the node and the corresponding number of transactions.',
    FourthLine: '4、Click the node or click the state to jump to the corresponding business function and search out the corresponding business.'
  },
  LineChartPopover: {
    FirstLine: '1、The traffic graph only shows the number of new business related to you in the last seven days.'
  },
  SopFilterContent: {
    SopFilterConditionsTip: 'Businesses that meet any of the following criteria will be counted in the SOP board',
    BusinessState: 'By business status',
    Operation: 'Is the operation',
    Submit: 'Has been submitted',
    Audit: 'The approved',
    Date: 'By date of business',
    ETD: 'Business Date (ETD) not earlier than',
    ETA: 'Business Date (ETA) not earlier than',
    Days: 'days before',
    PleaseInputDays: 'Please enter number of days',
    PleaseSelectBusinessType: 'Please select at least one business state',
    PreCommit: 'PreCommit'
  },
  QuickEntryLayer: {
    FirstLine: 'Click here for quick access to the function',
    SecondLine: 'Drag and drop the shortcut entry directly from the menu'
  },
  SopBoardLayer: {
    FirstLine: '1、The SOP nodes you are interested in are shown here',
    SecondLine: '2、Move the mouse over the node to display the number of businesses in each state under the node',
    ThirdLine: '3、The nodes and states shown are freely configurable'
  },
  LineChartLayer: {
    FirstLine: 'This shows the number of new business related to you in the last seven days'
  },
  SettingLayer: {
    FirstLine: 'Click here to take you to the configuration page'
  },
  NextStep: 'The next step',
  Loading: 'Loading',
  hasPermission: 'Sorry, You do not have permission',
  warningMessage: 'Warning message',
  ignoreMessage: 'Ignore message',
  ignoreSelected: 'Ignore selected',
  restoreSelected: 'Restore selected',
  ScreeningContent: 'Screening content:',
  Warning: 'Give early warning',
  nodeName: 'Node Name',
  nodeState: 'Node State',
  warningLevel: 'Warning Level',
  warningAt: 'Warning Time',
  warningContent: 'Warning Content',
  sift: 'Sift',
  toDoList: 'to-do list',
  SopWarning: 'Sop Warning',
  DelTrackingDetailConfirm: 'Note: The associated business details and sop nodes will be deleted',
  DelTrackingConfirm: 'Do you want to delete the node? After the node is deleted, the node of the related business document is also deleted.',
  copyTrackingTemplateConfirm: 'Copy the {0} template?',
  SelectTheNode: 'Select the node',
  StatusType: 'Status Type',
  AutomaticTriggering: 'Automatic triggering',
  ExternalEncoding: 'External encoding',
  ReportTemplate: 'Report Template',
  SendNotifications: 'Send notifications',
  NotSendNotifications: 'Send notifications',
  InitialState: 'Initial state'
}
